import { request } from '@/utils/request'

export const JobTitlesService = {
    async get(id) {
        return request.get(`/api/manage/job-titles/${id}`)
    },
    async update(id, title) {
        return request.put(`/api/manage/job-titles/${id}`, title)
    },
}
